import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import {type FC, type ReactNode} from "react";

type LoadingScreenProps = {
  loadingComponent?: ReactNode;
};

const LoadingScreen: FC<LoadingScreenProps> = ({loadingComponent}) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    textAlign="center"
    my={loadingComponent ? 0 : 4}>
    {loadingComponent || <CircularProgress size={40} />}
  </Box>
);

export default LoadingScreen;
